import styled from 'styled-components'
import { Body14, Eyebrow } from 'components/Typography'
import theme from 'styles/theme'
import { GatsbyImage } from 'gatsby-plugin-image'

export const Wrapper = styled.article`
  box-sizing: border-box;
  flex: none;

  @media screen and (max-width: ${parseInt(theme.breakpoints.md, 10) - 1}px) {
    margin-top: 60px;

    &:first-child {
      margin-top: 0;
    }
  }

  ${theme.mediaQueries.medium} {
    max-width: 380px;
    width: calc(33.33333% - 13.333334px);

    &:nth-child(n + 4) {
      margin-top: 20px;
    }

    &:nth-child(3n-1):last-child {
      margin-left: 20px;

      ${({ count }) =>
        count > 3 &&
        `
        margin-right: auto;
      `}
    }
  }
`

export const Anchor = styled.a`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const Image = styled(GatsbyImage)`
  display: block;
  height: 260px;
`

export const Content = styled.div`
  background: ${(props) => props.theme.colors.sagefeatherToSandStone};
  padding: 30px;
  text-align: center;
  flex-grow: 1;

  ${theme.mediaQueries.large} {
    padding: 40px 38px;
  }
`

export const Brow = styled(Eyebrow)`
  margin: 0 0 20px;
`

export const Body = styled(Body14)`
  color: ${(props) => props.theme.colors.sagemedium};
  margin: 0;
  min-height: 61px;
`
